/**
 * Injection point for StatusDerivation, which the analysis agent delivers in
 * src/features/twin/analysis. The simulator never imports it; whoever owns
 * the wiring registers a `(subsystemId, readings) => StatusLevel` callback
 * here and simulation.ts raises an alert when a component's derived level
 * changes to DEGRADED or OFFLINE (the old deriveRelatedStatuses rule).
 */
import type { Reading, StatusLevel } from '../types';

export type DeriveStatusHook = (subsystemId: string, readings: Record<string, Reading>) => StatusLevel;

let hook: DeriveStatusHook | null = null;

export function registerDeriveStatusHook(next: DeriveStatusHook | null): void {
  hook = next;
}

export function getDeriveStatusHook(): DeriveStatusHook | null {
  return hook;
}
